import React from "react";
import { Link } from "react-router-dom";

const CustomBreadcrumb = ({ items }) => {
  return (
    <nav className="flex " aria-label="Breadcrumb">
      <ol className="inline-flex items-center text-base">
        {items.map((item, index) => (
          <li key={index} className="inline-flex items-center">
            {item.link ? (
              <Link
                to={`/${item.link}`}
                className="text-gray-700 hover:text-darkCyan "
              >
                {item.title}
              </Link>
            ) : (
              <span className="text-darkCyan font-medium">{item.title}</span>
            )}
            {index < items.length - 1 && (
              <svg
                className="w-4 h-4 mx-1 text-gray-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default CustomBreadcrumb;
